import { Box } from '@chakra-ui/react';
import React from 'react';
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay';
import { CSSTransition } from 'react-transition-group';
import * as styles from './BottomSheet.module.css';
const BottomSheet = ({isOpen ,onClose , children}) => {
  return (
    <Box className={styles.root}>
      {isOpen && <LoadingOverlay 
      zIndex={100}
      clickEvent={onClose}
      loading={false} />}
      <CSSTransition
        in={isOpen}
        timeout={300}
        unmountOnExit

        classNames={{
          enter: styles.menuEnter,
          enterDone: styles.menuEnterActive,
          exit: styles.menuExit,
          exitActive: styles.menuExitActive
        }}
        //   onEnter={() => setSecondLevel(links)}
      >
        <Box
          maxH={'80vh'}
          h={'full'}
          bg={'white'}
          zIndex={110}
          bottom={0}
          w="full"
          left={0}
          position={'fixed'}
          borderRadius={'20px 20px 0 0'}
          px={4}
        >
          {children}
        </Box>
      </CSSTransition>
    </Box>
  );
};

export default BottomSheet;
